<template>
  <div>
    <p v-if="showBaseConditions" class="base-conditions-text">
      {{ $t("Conditions") }}:
      <strong>
        {{ snowReport.BaseConditions }}
      </strong>
    </p>
    <p v-if="showSeasonTotal">
      {{ $t("Season Total") }}:
      <strong>
        {{ seasonTotal }}
      </strong>
    </p>
    <p v-if="showSinceLiftsClosed">
      {{ textOptions.since_lifts_closed }}
      <strong>
        {{ sinceLiftsClosed }}
      </strong>
    </p>
    <p v-if="show24HourSnow">
      {{ $t(textOptions.twenty_four_hour_snow) }}
      <strong>
        {{ snow24Hours }}
      </strong>
    </p>
    <p v-if="show48HourSnow">
      {{ $t("48 hour") }}:
      <strong>
        {{ snow48Hours }}
      </strong>
    </p>
    <p v-if="show72HourSnow">
      {{ $t("72 hour") }}:
      <strong>
        {{ snow72Hours }}
      </strong>
    </p>
    <p v-if="show7DaySnow">
      {{ $t("7 day") }}:
      <strong>
        {{ snow7Days }}
      </strong>
    </p>
    <p v-if="showBase" class="base-text">
      {{ $t("Snow Base") }}:
      <strong>
        {{ snowBase }}
      </strong>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Conditions',
  props: ['snowReport', 'currentArea', 'snowbaseUnit'],
  components: { },
  methods: {
    roundValue(val) {
      if (this.weatherRoundSecondaryValues == true) {
        return Math.ceil(val * 1.0);
      }
      return val;
    },
  },
  computed: {
    showBaseConditions() {
      if (!this.weatherSecondaryLayoutOptions) { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('conditions') >= 0;
    },
    showSeasonTotal() {
      if (!this.weatherSecondaryLayoutOptions) { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('season_total') >= 0;
    },
    seasonTotal() {
      if (!this.snowReport) { return; }

      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.snowReport.SeasonTotalCm)} cm`
        : `${this.roundValue(this.snowReport.SeasonTotalIn)}\"`;
    },
    showSinceLiftsClosed() {
      if (!this.weatherSecondaryLayoutOptions) { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('toggle_overnight') >= 0;
    },
    sinceLiftsClosed() {
      if (!this.currentArea) { return; }

      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.currentArea.SinceLiftsClosedCm)} cm`
        : `${this.roundValue(this.currentArea.SinceLiftsClosedIn)}\"`;
    },
    show24HourSnow() {
      if (!this.weatherSecondaryLayoutOptions) { return; }
      if (this.currentArea.Last24HoursIn == '--') { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('toggle_24') >= 0;
    },
    snow24Hours() {
      if (!this.currentArea) { return; }

      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.currentArea.Last24HoursCm)} cm`
        : `${this.roundValue(this.currentArea.Last24HoursIn)}\"`;
    },
    show48HourSnow() {
      if (!this.weatherSecondaryLayoutOptions) { return; }
      if (this.currentArea.Last48HoursIn == '--') { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('toggle_48') >= 0;
    },
    snow48Hours() {
      if (!this.currentArea) { return; }

      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.currentArea.Last48HoursCm)} cm`
        : `${this.roundValue(this.currentArea.Last48HoursIn)}\"`;
    },
    show72HourSnow() {
      if (!this.weatherSecondaryLayoutOptions) { return; }
      if (this.currentArea.Last72HoursIn == '--') { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('toggle_72') >= 0;
    },
    snow72Hours() {
      if (!this.currentArea) { return; }

      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.currentArea.Last72HoursCm)} cm`
        : `${this.roundValue(this.currentArea.Last72HoursIn)}\"`;
    },
    show7DaySnow() {
      if (!this.weatherSecondaryLayoutOptions) { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('toggle_7') >= 0;
    },
    snow7Days() {
      if (!this.currentArea) { return; }

      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.currentArea.Last7DaysCm)} cm`
        : `${this.roundValue(this.currentArea.Last7DaysIn)}\"`;
    },
    showBase() {
      if (!this.weatherSecondaryLayoutOptions) { return; }

      return this.weatherSecondaryLayoutOptions.indexOf('toggle_base') >= 0;
    },
    snowBase() {
      if (!this.currentArea) { return; }
      return this.snowbaseUnit === 'metric'
        ? `${this.roundValue(this.currentArea.BaseCm)} cm`
        : `${this.roundValue(this.currentArea.BaseIn)}\"`;
    },
    ...mapGetters([
      'weatherSecondaryLayoutOptions',
      'weatherRoundSecondaryValues',
      'textOptions',
    ]),
  },
};
</script>

<style lang="scss" scoped>
p {
  font-family: $base-font-regular;
  font-size: 10px;
  margin: 0 0 5px 10%;
  white-space: nowrap;
  strong {
    font-family: $base-font-semibold;
    font-weight: 600;
  }
  @media (min-width: $tablet) {
    font-size: 14px;
  }
  &.base-conditions-text {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
}
</style>

<i18n locale="fr-ca">
{
  "Conditions": "Conditions",
  "Season Total": "Total saison",
  "24 hour": "24 h",
  "48 hour": "48 h",
  "72 hour": "72 h",
  "7 day": "7 jours",
  "Snow Base": "Snow Base"
}
</i18n>
